import { withdrawalJournal } from "./withdrawal-journal";

withdrawalJournal.install();
